<template>
  <div>
    <div class="matching-box clearfix">
      <vxe-form
          :data="formData"
          :rules="formRules"
          title-colon
          ref="xForm"
          title-width="120"
          title-align="right"
      >
        <vxe-form-item title="车船号" field="carShipNum" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail"
                 style="display: flex;align-items: center">
              <a v-if="formData.logisticsType === 1" @click="showCarDetail(formData)">{{
                  formData.carShipNum
                }}</a>
              <a v-if="formData.logisticsType === 2" @click="showShipDetail(formData)">{{
                  formData.carShipNum
                }}</a>
              <div style="display: flex;align-items: center;justify-content:center;margin-left: auto;cursor: pointer">
                <img v-if="formData.trackUrl || formData.logisticsType === 2"
                     style="width: 20px;height: 20px;" src="@/assets/images/common/icon-guiji.png"
                     @click="getMap(formData)"/>
                <img v-else style="width: 20px;height: 20px;" src="@/assets/images/common/icon-noguiji.png"/>
              </div>
            </div>
            <a
                class="matching-sel-link"
                @click="openCarShip(carShipType)"
                target="_black"
                v-else
            >{{
                formData.carShipNum === null || formData.carShipNum === ""
                    ? "请选择车船"
                    : formData.carShipNum
              }}</a
            >
          </template>
        </vxe-form-item>
        <vxe-form-item title="轨迹状态" field="logisticsState" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2"
                 v-if="isDetail && !isHavePermission('matchOrder:detail:updateLogisticsState')">
              {{ formData.logisticsState | logisticsIsTopStatusMap }}
            </div>
            <vxe-select
                v-if="isDetail && isHavePermission('matchOrder:detail:updateLogisticsState')"
                v-model="formData.logisticsState"
                placeholder="请选择"
                :options="trackStateOptions"
                @change="updateLogisticsState"
                transfer
            ></vxe-select>
            <vxe-select
                v-if="!isDetail"
                v-model="formData.logisticsState"
                placeholder="请选择"
                :options="trackStateOptions"
                @change="clearValidate"
                transfer
            ></vxe-select>
          </template>
        </vxe-form-item>

        <vxe-form-item title="起运地" field="beginPlaceAddress" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              {{ beginPlace }}
            </div>
            <div class="address-box" v-else>
              <vxe-select
                  v-model="formData.beginPlacePro"
                  :options="cityData"
                  @change="loadCity(formData.beginPlacePro, 1)"
                  v-show="busType === 2"
                  placeholder="省"
                  transfer
              ></vxe-select>
              <vxe-select
                  v-model="formData.beginPlaceCity"
                  :options="formData.cityOptions"
                  @change="
                loadArea(formData.beginPlacePro, formData.beginPlaceCity, 1)
              "
                  v-show="busType === 2"
                  placeholder="市"
                  transfer
              ></vxe-select>
              <vxe-select
                  v-model="formData.beginPlaceArea"
                  :options="formData.areaOptions"
                  v-show="busType === 2"
                  placeholder="区"
                  @change="clearValidate"
                  transfer
              ></vxe-select>
              <vxe-input
                  v-model="formData.beginPlaceAddress"
                  placeholder="详细地址"
                  :style="busType === 2 ? 'width:31%' : 'width:100%'"
                  @input="clearValidate"
              ></vxe-input>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运时间" field="beginTime" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              {{ formData.beginTime ? formData.beginTime.slice(0, 10) : '' }}
            </div>
            <vxe-input
                v-model="formData.beginTime"
                placeholder="选择日期"
                :type="busType === 2 ? 'datetime' : 'date'"
                transfer
                v-else
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达地" field="endPlaceAddress" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              {{ endPlace }}
            </div>
            <div class="address-box" v-else>
              <vxe-select
                  v-model="formData.endPlacePro"
                  :options="cityData"
                  @change="loadCity(formData.endPlacePro, 2)"
                  v-show="busType === 2"
                  placeholder="省"
                  transfer
              ></vxe-select>
              <vxe-select
                  v-model="formData.endPlaceCity"
                  :options="formData.endCityOptions"
                  @change="loadArea(formData.endPlacePro, formData.endPlaceCity, 2)"
                  v-show="busType === 2"
                  placeholder="市"
                  transfer
              ></vxe-select>
              <vxe-select
                  v-model="formData.endPlaceArea"
                  :options="formData.endAreaOptions"
                  v-show="busType === 2"
                  placeholder="区"
                  @change="clearValidate"
                  transfer
              ></vxe-select>
              <vxe-input
                  v-model="formData.endPlaceAddress"
                  placeholder="详细地址"
                  :style="busType === 2 ? 'width:31%' : 'width:100%'"
                  @click="clearValidate"
              ></vxe-input>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达时间" field="endTime" span="8">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              {{ formData.endTime ? formData.endTime.slice(0, 10) : '' }}
            </div>
            <vxe-input
                v-model="formData.endTime"
                placeholder="选择日期"
                :type="busType === 2 ? 'datetime' : 'date'"
                transfer
                v-else
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="物流单据" field="logisticsFiles" span="24">
          <template>
            <div class="matching-inner-box matching-inner-box-2" v-if="isDetail">
              <upload-detail :arrList="formData.logisticsFiles"></upload-detail>
            </div>
            <div class="matching-inner-box" v-else>
              <upload-list
                  :row="formData"
                  :initFileList="formData.logisticsFiles"
                  :view="'packup'"
                  ref="uploadlist"
              ></upload-list>
            </div>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <vxe-modal v-model="carShipVisible" title="选择车船" width="1300" height="600" resize position="center">
      <choose-car-ship ref="carShipModal" @choose="chooseCarShip"></choose-car-ship>
    </vxe-modal>
    <vxe-modal v-model="createCarVisible" :title="createCarTitle" width="1400" height="860" @close="closeCarCreate"
               resize position="center">
      <create-car-modal @afterSave="closeCarCreateModal" ref="modalCarCreate" @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal v-model="createShipVisible" :title="createShipTitle" width="1400" height="900" @close="closeShipCreate"
               resize position="center" destroy-on-close>
      <create-ship-modal @afterSave="closeShipCreateModal" @close="createShipVisible = false"
                         ref="modalShipCreate"></create-ship-modal>
    </vxe-modal>
  </div>
</template>

<script>
import UploadList from "@/components/common/UploadList";
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import UploadDetail from "@/components/common/UploadDetail";
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";
import {hideLoading, isEmpty, isNotEmpty, showLoading} from "@/utils/util";
import moment from "moment";
import $C from "@/consts";
import {mapGetters} from "vuex";
import getAuthOrization from "@/mixin/getAuthOrization";
import $api from "@/apiProvider";

var appData = require("@/assets/json/zz.json");
export default {
  mixins: [getAuthOrization],
  props: {
    busType: Number,
    isSubmit: Boolean,
    detailData: Object,
    isDetail: {
      default: false,
      type: Boolean
    }
  },
  components: {
    UploadList,
    ChooseCarShip,
    UploadDetail,
    CreateCarModal,
    CreateShipModal
  },
  data() {
    const beginPlaceValid = () => {
      if (
          this.busType === 2 &&
          (isEmpty(this.formData.beginPlacePro) ||
              isEmpty(this.formData.beginPlaceCity) ||
              isEmpty(this.formData.beginPlaceArea))
      ) {
        return new Error("请填写详细地址");
      }
    };
    const endPlaceValid = () => {
      if (
          this.busType === 2 &&
          (isEmpty(this.formData.endPlacePro) ||
              isEmpty(this.formData.endPlaceCity) ||
              isEmpty(this.formData.endPlaceArea))
      ) {
        return new Error("请填写详细地址");
      }
    };
    return {
      formData: {
        carShipNum: null,
        carShipId: null,
        transportationType: null,
        beginTime: null,
        endTime: null,
        logisticsFiles: null,
        // beginPlace: null,
        beginPlacePro: null,
        beginPlaceCity: null,
        beginPlaceArea: null,
        beginPlaceAddress: null,
        // endPlace: null,
        endPlacePro: null,
        endPlaceCity: null,
        endPlaceArea: null,
        endPlaceAddress: null,
        logisticsState: null,
      },
      formRules: {
        carShipNum: [{required: true, message: "请选择车船"}],
        beginTime: [{required: true, message: "请选择起运时间"}],
        beginPlaceAddress: [
          {required: true, message: "请填写详细地址"},
          {validator: beginPlaceValid}
        ],
        endPlaceAddress: [
          {required: true, message: "请填写详细地址"},
          {validator: endPlaceValid}
        ]
      },
      carShipVisible: false,
      cityData: [],
      beginPlace: null,
      endPlace: null,
      createCarVisible: false,
      createShipVisible: false,
      createCarTitle: "",
      createShipTitle: "",
      trackStateOptions: $C.LogisticsIsTopStatus.options,
    };
  },
  computed: {
    ...mapGetters(["chooseMatchingAgreementObjGetter"]),
    carShipType() {
      return this.busType ? (this.busType === 2 ? 2 : 1) : null;
    }
  },
  watch: {
    "formData.beginTime": {
      handler(nv, ov) {
        if (nv !== ov) {
          this.clearValidate();
        }
      }
    },
    isSubmit(val) {
      if (val) {
        this.setParams();
      }
    },
    busType(val) {
      this.formData.carShipNum = null;
      this.formData.carShipId = null;
    },
    detailData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.beginPlace = val.beginPlace;
          this.endPlace = val.endPlace;
          this.formData.carShipNum = val.carShipNum;
          this.formData.carShipId = val.carShipId;
          this.formData.transportationType = val.transportationType;
          this.formData.beginTime = val.beginTime
              ? moment(val.beginTime).format("YYYY-MM-DD HH:mm:ss")
              : null;
          this.formData.endTime = val.endTime
              ? moment(val.endTime).format("YYYY-MM-DD HH:mm:ss")
              : null;
          this.formData.preBeginTime = val.preBeginTime;
          this.formData.preBeginTimeDays = val.preBeginTimeDays;
          this.formData.logisticsFiles = val.logisticsFileList;
          this.formData.beginPlacePro = val.beginPlacePro;
          this.formData.beginPlaceCity = val.beginPlaceCity;
          this.formData.beginPlaceArea = val.beginPlaceArea;
          this.formData.beginPlaceAddress = val.beginPlaceAddress;
          this.formData.endPlacePro = val.endPlacePro;
          this.formData.endPlaceCity = val.endPlaceCity;
          this.formData.endPlaceArea = val.endPlaceArea;
          this.formData.endPlaceAddress = val.endPlaceAddress;
          this.formData.logisticsType = val.logisticsType;
          this.formData.trackUrl = val.trackUrl;
          this.$set(this.formData, 'logisticsState', val.logisticsState);
          // this.formData.logisticsState = val.logisticsState;
        }
      }
    },
    chooseMatchingAgreementObjGetter(val) {
      // console.log(val);
      this.formData.carShipId = val.carShipId;
      this.formData.carShipNum = val.carShipNum;
      this.formData.beginTime = val.beginTime
          ? moment(val.beginTime).format("YYYY-MM-DD HH:mm:ss")
          : null;
      if (val.dataType === 2) {
        //运输模板
        this.formData.beginPlaceAddress = val.beginPlaceDetail;
        this.formData.endPlaceAddress = val.endPlaceDetail;

        if (val.carShipType !== 2) {
          // 陆运
          this.formData.beginPlacePro = val.beginPlacePro;
          this.formData.beginPlaceCity = val.beginPlaceCity;
          this.formData.beginPlaceArea = val.beginPlaceArea;
          this.formData.endPlacePro = val.endPlacePro;
          this.formData.endPlaceCity = val.endPlaceCity;
          this.formData.endPlaceArea = val.endPlaceArea;
          this.formData.cityOptions = this.getCityOptions(val.beginPlacePro);
          this.formData.endCityOptions = this.getCityOptions(val.endPlacePro);
          this.formData.areaOptions = this.getAreaOptions(val.beginPlacePro, val.beginPlaceCity);
          this.formData.endAreaOptions = this.getAreaOptions(val.endPlacePro, val.endPlaceCity);
          this.formData.endTime = val.endTime
              ? moment(val.endTime).format("YYYY-MM-DD HH:mm:ss")
              : null;
        } else {
          this.formData.beginPlacePro = null;
          this.formData.beginPlaceCity = null;
          this.formData.beginPlaceArea = null;
          this.formData.endPlacePro = null;
          this.formData.endPlaceCity = null;
          this.formData.endPlaceArea = null;
          this.formData.endTime = null;
        }
      } else {
        //自定义模板
        this.formData.beginPlaceAddress = val.beginPlace;
        this.formData.endPlaceAddress = val.endPlace;
        this.formData.beginPlacePro = null;
        this.formData.beginPlacePro = null;
        this.formData.beginPlaceCity = null;
        this.formData.beginPlaceArea = null;
        this.formData.endPlacePro = null;
        this.formData.endPlaceCity = null;
        this.formData.endPlaceArea = null;
        this.formData.endTime = null;
      }
    },
  },
  created() {
    this.getDicDate();
  },
  methods: {
    async updateLogisticsState(e) {
      showLoading();
      let res = await $api.matchOrder.post("updateLogisticsState", {
        id: this.detailData.id,
        logisticsState: e.value
      });
      if (res.status === 1) {
        hideLoading();
        this.$Message.success("修改成功！");
        this.$emit('refresh');
      } else {
        hideLoading();
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    clearValidate() {
      this.$refs.xForm.clearValidate();
    },
    getDicDate() {
      appData.forEach(item => {
        let obj = {
          value: item.label,
          label: item.label
        };
        this.cityData.push(obj);
      });
    },
    async setParams() {
      const errMap = await this.$refs.xForm.validate().catch(errMap => errMap);
      if (errMap) {
        this.$emit("setParams", false);
        return;
      } else {
        let params = {
          carShipNum: this.formData.carShipNum,
          carShipId: this.formData.carShipId,
          transportationType: this.formData.transportationType,
          beginTime: this.formData.beginTime ? moment(this.formData.beginTime).valueOf() : null,
          endTime: this.formData.endTime ? moment(this.formData.endTime).valueOf() : null,
          logisticsFiles: this.formData.fileUuidList,
          beginPlacePro: this.formData.beginPlacePro,
          beginPlaceCity: this.formData.beginPlaceCity,
          beginPlaceArea: this.formData.beginPlaceArea,
          beginPlaceAddress: this.formData.beginPlaceAddress,
          endPlacePro: this.formData.endPlacePro,
          endPlaceCity: this.formData.endPlaceCity,
          endPlaceArea: this.formData.endPlaceArea,
          endPlaceAddress: this.formData.endPlaceAddress,
          logisticsState: this.formData.logisticsState,
          preBeginTime: this.formData.preBeginTime,
          preBeginTimeDays: this.formData.preBeginTimeDays
        };
        this.$emit("setParams", params);
      }
    },
    openCarShip(type) {
      this.carShipVisible = true;
      this.$refs.carShipModal.init(type);
    },
    chooseCarShip(row, type) {
      this.clearValidate();
      if (type === "ship") {
        this.formData.carShipNum = row.shipName;
        this.formData.carShipId = row.id;
        this.formData.transportationType = 2;
      } else {
        this.formData.carShipNum = row.carNum;
        this.formData.carShipId = row.id;
        this.formData.transportationType = 1;
      }
      this.$refs.carShipModal.close();
      this.carShipVisible = false;
    },
    getCityOptions(province) {
      if (isEmpty(province)) {
        return [];
      }
      let options;
      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
          isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        options = arr;
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        options = cityArr;
      }
      return options;
    },
    getAreaOptions(province, city) {
      if (isEmpty(province)) {
        return [];
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      return arr;
    },
    loadCity(province, type, isImpot = false) {
      this.clearValidate();
      if (!isImpot) {
        if (type === 1) {
          this.formData.beginPlaceCity = "";
          this.formData.beginPlaceArea = "";
        } else {
          this.formData.endPlaceCity = "";
          this.formData.endPlaceArea = "";
        }
      }

      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
          isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        type === 1
            ? (this.formData.cityOptions = arr)
            : (this.formData.endCityOptions = arr);
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        type === 1
            ? (this.formData.cityOptions = cityArr)
            : (this.formData.endCityOptions = cityArr);
      }
    },
    loadArea(province, city, type, isImpot = false) {
      this.clearValidate();
      if (!isImpot) {
        if (type === 1) {
          this.formData.beginPlaceArea = "";
        } else {
          this.formData.endPlaceArea = "";
        }
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      type === 1
          ? (this.formData.areaOptions = arr)
          : (this.formData.endAreaOptions = arr);
    },
    showCarDetail(row) {
      if (row.carShipId) {
        this.createCarTitle = "查看车辆信息";
        this.createCarVisible = true;
        this.$refs.modalCarCreate.init();
        this.$refs.modalCarCreate.queryCarDetail(row.carShipId);
        this.$refs.modalCarCreate.setReadOnly();
      } else {
        this.$XModal.alert({
          message: "暂无车辆信息",
          status: "error"
        });
      }
    },
    showShipDetail(row) {
      if (row.carShipId) {
        this.createShipTitle = "查看船舶信息";
        this.createShipVisible = true;
        this.$nextTick(() => {
          this.$refs.modalShipCreate.queryShipDetailNew(row.carShipId);
          this.$refs.modalShipCreate.setReadOnly();
        });
      } else {
        this.$XModal.alert({
          message: "暂无船舶信息",
          status: "error"
        });
      }
    },
    closeCarCreateModal(type) {
      this.createCarVisible = false;
    },
    closeCarCreate() {
      this.$refs.modalCarCreate.reset();
    },
    closeCar() {
      this.createCarVisible = false;
      this.$refs.modalCarCreate.clearV();
    },
    closeShipCreateModal() {
      this.createShipVisible = false;
      // this.queryLogisticsList();
    },
    closeShipCreate() {
      this.$refs.modalShipCreate.reset();
    },
    getMap(row) {
      if (row.logisticsType === 1) {
        this.seeCarMap(row)
      } else {
        this.seeShipMap(row);
      }
    },
    seeCarMap(row) {
      let that = this;
      let url = '/carShip/fwCarFrame';
      this.fwCar = window.open(url);
      setTimeout(function () {
        that.fwCar.postMessage(JSON.stringify({carInfo: row, logistics: true}), '*');
      }, 2000);
    },
    seeShipMap(row) {
      let mmsi = row.mmsi;
      let carShipNum = row.carShipNum;
      if ((mmsi == null || mmsi === '') && (carShipNum === null || carShipNum === '')) {
        //暂无数据
        this.$Message.error('暂无数据');
        return
      }
      let beginTime = moment(row.beginTime).format("YYYY-MM-DD");
      let deliveryDates = moment(row.endTime).format("YYYY-MM-DD")
      let obj = {
        startTime: beginTime + " 00:00:00",
        endTime: deliveryDates + " 00:00:00",
        mmsi: mmsi,
        carShipNum: carShipNum,
      }
      let that = this;
      let url = '/carShip/fwShipFrame';
      this.fwShip = window.open(url);
      this.$nextTick(function () {
        setTimeout(function () {
          that.fwShip.postMessage(JSON.stringify(obj), '*')
        }, 2000);
      });
    },
    // 船舶日期往前推N天
    dateAddDays(dataStr, dayCount) {
      let isdate = new Date(dataStr.replace(/-/g, "/"));
      isdate = new Date((isdate / 1000 - (86400 * dayCount)) * 1000);//日期-N天
      let strMonth = isdate.getMonth() + 1;
      let strDate = isdate.getDate();
      let strYear = isdate.getFullYear();
      if (strMonth >= 1 && strMonth <= 9) {
        strMonth = "0" + strMonth;
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      return strYear + "-" + strMonth + "-" + strDate;
    },
  }
};
</script>

<style>
</style>